import React from 'react'
import {
  lastSuportedReleases,
  lastRelease,
  mainDocsUrl,
  algoliaReleases,
} from '../../config/site'
import {pathJoin} from '../../utils/helpers'
import {Link} from '../Link'
import {useGatsbyData} from '../../context/gatsbyDataContext'
import './VersionsButton.scss'

function VersionsButton() {
  const {
    pageContext,
    location,
    data: {releasesForSlug},
  } = useGatsbyData()

  const {pathString: slug, type} = pageContext
  const slugReleases =
    type === 'older-versions'
      ? []
      : releasesForSlug.edges.map(({node}) => node.fields.release)

  const isHome = location.pathname === '/'

  return (
    <div className="dropdown show">
      <button
        className="btn dropdown-toggle"
        id="dropdownMenuLink"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        v{useGatsbyData().pageContext.release}
      </button>

      <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
        {lastSuportedReleases.map(release => (
          <React.Fragment key={release}>
            {algoliaReleases.includes(release) ? (
              <Link
                partiallyactive="true"
                className={
                  isHome && release === lastRelease
                    ? 'gray-color'
                    : 'dropdown-item'
                }
                activeclassname="gray-color"
                haslocale="true"
                to={pathJoin(
                  release,
                  slugReleases.includes(release) ? slug : '',
                )}
              >
                {release}
              </Link>
            ) : (
              <a
                partiallyactive="true"
                className={
                  isHome && release === lastRelease
                    ? 'gray-color'
                    : 'dropdown-item'
                }
                activeclassname="gray-color"
                haslocale="true"
                href={mainDocsUrl + '/' + release}
              >
                {release}
              </a>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default VersionsButton
